import React from "react"
import { connect } from "react-redux"
import { navigate } from "gatsby"
import API, { graphqlOperation } from "@aws-amplify/api"
import ActivitySelector from "../ActivitySelector"
import {
  saveStepAndGoNext,
  setActivity,
  setActivityName,
  setActivitySelectStage,
} from "../../state/actions/questionnaire"
import { trackAmplitude } from "../../helpers/amplitude"
import { trackSegmentEvent } from "../../helpers/segment"

const Activity = ({
  basepath,
  initDetails,
  initSelectedId,
  setActivity,
  setActivityName,
  setActivitySelectStage,
  step,
  saveStepAndGoNext,
  type,
}) => {
  const successCallback = async (id, title, details) => {
    setActivity(id)
    setActivityName(details)
    setActivitySelectStage(1)

    trackSegmentEvent("track", "Select activity", {
      activityId: id,
      activityName: title,
      activityDetails: details,
    })

    trackAmplitude("Select activity", {
      activityId: id,
      activityName: title,
      activityDetails: details,
    })

    setTimeout(() => {
      navigate(`${basepath}${step + 1}`)
      if (type === "private") saveStepAndGoNext(API, graphqlOperation)
    }, 250)
  }

  return (
    <ActivitySelector
      buttonLabel="next →"
      initDetails={initDetails}
      initSelectedId={initSelectedId}
      successCallback={successCallback}
    />
  )
}

export default connect(
  ({ questionnaire }) => ({
    initSelectedId: `_${questionnaire.activityId}`,
    initDetails: questionnaire.activityName,
  }),
  { saveStepAndGoNext, setActivity, setActivityName, setActivitySelectStage }
)(Activity)
